import styled from 'styled-components';
import AbstractTextElement from 'UIComponents/elements/AbstractTextElement';
/**
 * @deprecated use marketplace-ui-common
 */

const BigText = styled(AbstractTextElement).withConfig({
  displayName: "BigText",
  componentId: "sc-1c5e79t-0"
})(["&&{font-size:16px;line-height:28px;}"]);
export default BigText;